import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { SingleUseTokensListPage } from '@/components/user/SingleUseTokensListPage';

export default function EInvoiceTokensPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <SingleUseTokensListPage variant="e-invoice" pageTitle="E-Invoice Tokens" />
            </MainLayout>
        </ProtectedRoute>
    );
}
